import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { CustomButton, CustomTable } from '../../shared/uiComponents';
import { Container } from '../../components/StyledComponents';
import { Headers, TableBody } from './tableInfo';
import MobileView from './mobileView';

import { DispatchProperties, useSelector } from '../../redux/store';
import { getRoles } from '../../redux/State/identitySlice/roleSlice';
import { PageHeader } from '../../components/PageHeader';
import { Sliders } from '../../shared/Assets/menuIcons';
import { PlusIcon } from '../../shared/Assets/svg';

const Permissions = () => {
	const dispatch = useDispatch<DispatchProperties>();
	const navigate = useNavigate();

	const roles = useSelector((state) => state.role.roles);
	const loading = useSelector((state) => state.role.loading);

	const addCustomRoleHandler = () => {
		navigate('/permissions/new');
	};

	useEffect(() => {
		dispatch(getRoles());
	}, [dispatch]);

	return (
		<Container>
			<div style={{ display: 'flex' }}>
				<PageHeader
					icon={<Sliders />}
					title="Permissions"
					isInContainer
					customStyles={{ marginBottom: '24px' }}
					headerContent={
						<CustomButton title="Add custom role" onClick={addCustomRoleHandler} startIcon={<PlusIcon />} />
					}
				/>
			</div>
			<CustomTable
				headers={Headers}
				data={{ query: roles }}
				TableBody={TableBody}
				loading={loading}
				hasPagination={false}
			/>
			<MobileView data={roles} />
		</Container>
	);
};

export default Permissions;
